<template>
  <container 
    subHeaderTitle="PASS프라임"
    subHeaderText="PASS의 인기 컨텐츠 4종을 (신용정보, 금융인증, 주식정보, 금융정보)를<br class='br' />한번에 이용할 수 있는 편집형 구독 서비스 입니다. "
    subHeaderImage="pass_by_skt.svg" 
    subHeaderColor
  >
    <section class="service-top">
      <v-container class="py-0">
        <v-row>
          <v-col cols="12" xl="8" offset-xl="2" class="service-top-bg sevice-passprime">
            <div class="py-0 d-sm-flex align-center">
              <div>
                <p class="text-title">간편하고 편리한 PASS,<br /><b>구독도 심플하고 편리하게!</b></p>
                <p class="text-content">금융기관의 휴대폰 인증 성공 / 실패 이력 정보 제공하며,<br />신용점수, 대출, 카드,연체, 보증 등 신용정보 관리할 수 있습니다.<br />주식투자 컨텐츠와 카드 이용내역 / 계좌 관리까지<br/>한번에 편리하게 이용할 수 있습니다.</p>
                <!-- <v-btn depressed rounded x-large color="#647CF2" href="/cscenter/passprime/contract" @click="aaaa()" >편리하게 구독하기</v-btn> -->
                <v-btn depressed rounded x-large color="#647CF2" @click.stop="openExternalPage($event, supportJoinUrls.passPrime)" :data-ga-category="gaEvent.category.service.passprime.name" :data-ga-label="gaEvent.category.service.passprime.label1" :data-ga-action="gaEvent.actions.buttonClick">편리하게 구독하기</v-btn>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </section>
    <section class="service-center">
      <v-container class="py-0">
        <v-row>
          <v-col cols="12" xl="8" offset-xl="2" class="py-0">
            <v-row>
              <v-col cols="12" sm="6" class="py-0 d-flex align-center">
                <img ref="serviceImage" class="service-center-img" src="@/assets/new/image/service/service_passprime_center.svg" alt="">
              </v-col>
              <v-col cols="12" sm="6" class="py-0 d-flex flex-column justify-center">
                <div class="service-center-list">
                  <div class="icon">
                    <img src="@/assets/new/image/service/service_passprime_icon_1.svg" alt="">
                  </div>
                  <div class="copy">
                    <p class="text-content">금융 거래는 안전하게</p>
                    <p class="text-title">금융 인증 실시간 모니터링 및 알림</p>
                  </div>
                </div>
                <div class="service-center-list">
                  <div class="icon">
                    <img src="@/assets/new/image/service/service_passprime_icon_2.svg" alt="">
                  </div>
                  <div class="copy">
                    <p class="text-content">KCB가 제공하는 신용정보</p>
                    <p class="text-title">신용 점수 조회, 신용 변동 모니터링</p>
                  </div>
                </div>
                <div class="service-center-list">
                  <div class="icon">
                    <img src="@/assets/new/image/service/service_passprime_icon_3.svg" alt="">
                  </div>
                  <div class="copy">
                    <p class="text-content">투자 성향별 AI 포트폴리오에서 IPO 정보까지</p>
                    <p class="text-title">주식 투자 정보 콘텐츠</p>
                  </div>
                </div>
                <div class="service-center-list">
                  <div class="icon">
                    <img src="@/assets/new/image/service/service_passprime_icon_4.svg" alt="">
                  </div>
                  <div class="copy">
                    <p class="text-content">소중한 내 돈을 관리하는 습관</p>
                    <p class="text-title">카드 / 계좌 정보 조회 및 모니터링</p>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </section>
    <section class="service-end">
      <v-container class="py-0">
        <v-row>
          <v-col cols="12" xl="8" offset-xl="2" class="py-0">
            <v-row>
              <v-col cols="12" sm="4" class="py-0">
                <p class="text-title">꼭 필요한 정보는 한눈에!</p>
                <p class="text-content">신용정보, 금융인증 정보를 비롯하여,<br />필요한 정보를 한눈에 확인할 수 있습니다.</p>
                <div class="service-end-img">
                  <img ref="serviceImg1" src="@/assets/new/image/service/service_passprime_my_prime.png" alt="">
                </div>
              </v-col>
              <v-col cols="12" sm="4" class="py-0">
                <p class="text-title">신용 정보는 꼼꼼하게</p>
                <p class="text-content">KCB 기준의 신용정보를<br />보다 상세하게 확인할 수 있습니다.</p>
                <div class="service-end-img">
                  <img ref="serviceImg2" src="@/assets/new/image/service/service_passprime_credit.png" alt="">
                </div>
              </v-col>
              <v-col cols="12" sm="4" class="py-0">
                <p class="text-title">안전한 금융거래</p>
                <p class="text-content">금융기관의 금융인증 정보를 모니터링하여,<br />안전한 금융거래를 돕습니다.</p>
                <div class="service-end-img">
                  <img ref="serviceImg3" src="@/assets/new/image/service/service_passprime_safe.png" alt="">
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </section>
  </container>
</template>

<script>
import Container from "@/pages/container/index.vue";

import {GaTracking} from "@/mixins/index.js";

export default {
  mixins: [GaTracking],
  name: "PassPrime",
  components: {
    Container,
  },
  props: {},
  data() {
    return {
      supportJoinUrls: {
        passPrime: process.env.VUE_APP_PRIME_EXT_URL + "skt?chanCd=F100"
      }
    };
  },
  computed: {},
  methods: {
    getImageHeight() {
      this.$refs.serviceImage.style.height = Math.ceil(this.$refs.serviceImage.clientWidth) + "px"
      /*this.$refs.serviceImg1.style.height = Math.ceil(this.$refs.serviceImg1.clientWidth * 2.37) + "px"
      this.$refs.serviceImg2.style.height = Math.ceil(this.$refs.serviceImg2.clientWidth * 2.37) + "px"
      this.$refs.serviceImg3.style.height = Math.ceil(this.$refs.serviceImg3.clientWidth * 2.37) + "px"*/
    },
    openExternalPage(e, url) {
      this.gaTracking(e);
      window.open(url, "_blank");
    },

  },
  created() {
    window.addEventListener('resize', this.getImageHeight)
  },
  mounted() {
    this.getImageHeight();
  },
  destroyed() {
    window.removeEventListener('resize', this.getImageHeight)
  }
};
</script>

<style lang="scss" scoped>
@import "@/styles/service";
</style>
